/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as StudioRouteImport } from './routes/_studio';
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password';
import { Route as PlatformRouteImport } from './routes/platform';
import { Route as ResetPasswordRouteImport } from './routes/reset-password';
import { Route as SignInRouteImport } from './routes/sign-in';
import { Route as SignUpRouteImport } from './routes/sign-up';
import { Route as TenantsRouteImport } from './routes/tenants';
import { Route as StudioAccountRouteImport } from './routes/_studio/account';
import { Route as StudioAgencyRouteImport } from './routes/_studio/agency';
import { Route as StudioBlockedRouteImport } from './routes/_studio/blocked';
import { Route as StudioBrandingRouteImport } from './routes/_studio/branding';
import { Route as StudioBrandsRouteImport } from './routes/_studio/brands';
import { Route as StudioCachingRouteImport } from './routes/_studio/caching';
import { Route as StudioChannelsRouteImport } from './routes/_studio/channels';
import { Route as StudioChatWidgetRouteImport } from './routes/_studio/chat-widget';
import { Route as StudioChecksRouteImport } from './routes/_studio/checks';
import { Route as StudioConnectorsRouteImport } from './routes/_studio/connectors';
import { Route as StudioCustomerIdentityRouteImport } from './routes/_studio/customer-identity';
import { Route as StudioDecisionsRouteImport } from './routes/_studio/decisions';
import { Route as StudioDeveloperRouteImport } from './routes/_studio/developer';
import { Route as StudioFinanceRouteImport } from './routes/_studio/finance';
import { Route as StudioHoursRouteImport } from './routes/_studio/hours';
import { Route as StudioInboxRouteImport } from './routes/_studio/inbox';
import { Route as StudioKnowledgeRouteImport } from './routes/_studio/knowledge';
import { Route as StudioMigrationRouteImport } from './routes/_studio/migration';
import { Route as StudioModelsRouteImport } from './routes/_studio/models';
import { Route as StudioOnboardingRouteImport } from './routes/_studio/onboarding';
import { Route as StudioOverviewRouteImport } from './routes/_studio/overview';
import { Route as StudioReportsRouteImport } from './routes/_studio/reports';
import { Route as StudioRunsRouteImport } from './routes/_studio/runs';
import { Route as StudioSavedRepliesRouteImport } from './routes/_studio/saved-replies';
import { Route as StudioSecurityRouteImport } from './routes/_studio/security';
import { Route as StudioStopAiRouteImport } from './routes/_studio/stop-ai';
import { Route as StudioSupportTeamsRouteImport } from './routes/_studio/support-teams';
import { Route as StudioTeamRouteImport } from './routes/_studio/team';
import { Route as StudioToolsRouteImport } from './routes/_studio/tools';
import { Route as StudioVisitorsRouteImport } from './routes/_studio/visitors';
import { Route as StudioWorkflowsRouteImport } from './routes/_studio/workflows';
import { Route as InvitationsAcceptRouteImport } from './routes/invitations.accept';
import { Route as SsoDoneRouteImport } from './routes/sso.done';
import { Route as StudioAgentsIndexRouteImport } from './routes/_studio/agents/index';
import { Route as StudioAgentsAgentIdRouteImport } from './routes/_studio/agents/$agentId';
import { Route as StudioAutomationsIndexRouteImport } from './routes/_studio/automations/index';
import { Route as StudioAutomationsAutomationIdRouteImport } from './routes/_studio/automations/$automationId';
import { Route as StudioConnectMcpRouteImport } from './routes/_studio/connect.mcp';
import { Route as StudioInboxIndexRouteImport } from './routes/_studio/inbox/index';
import { Route as StudioInboxConversationIdRouteImport } from './routes/_studio/inbox/$conversationId';
import { Route as StudioMemoryIndexRouteImport } from './routes/_studio/memory/index';
import { Route as StudioMemoryCustomerIdRouteImport } from './routes/_studio/memory/$customerId';
import { Route as StudioOrdersIndexRouteImport } from './routes/_studio/orders/index';
import { Route as StudioOrdersOrderIdRouteImport } from './routes/_studio/orders/$orderId';
import { Route as StudioSettingsBillingRouteImport } from './routes/_studio/settings.billing';
import { Route as StudioSettingsPrivacyRouteImport } from './routes/_studio/settings.privacy';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const StudioRoute = StudioRouteImport.update({
  id: '/_studio',
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any);
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any);
const TenantsRoute = TenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => rootRouteImport,
} as any);
const StudioAccountRoute = StudioAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => StudioRoute,
} as any);
const StudioAgencyRoute = StudioAgencyRouteImport.update({
  id: '/agency',
  path: '/agency',
  getParentRoute: () => StudioRoute,
} as any);
const StudioBlockedRoute = StudioBlockedRouteImport.update({
  id: '/blocked',
  path: '/blocked',
  getParentRoute: () => StudioRoute,
} as any);
const StudioBrandingRoute = StudioBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => StudioRoute,
} as any);
const StudioBrandsRoute = StudioBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => StudioRoute,
} as any);
const StudioCachingRoute = StudioCachingRouteImport.update({
  id: '/caching',
  path: '/caching',
  getParentRoute: () => StudioRoute,
} as any);
const StudioChannelsRoute = StudioChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => StudioRoute,
} as any);
const StudioChatWidgetRoute = StudioChatWidgetRouteImport.update({
  id: '/chat-widget',
  path: '/chat-widget',
  getParentRoute: () => StudioRoute,
} as any);
const StudioChecksRoute = StudioChecksRouteImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => StudioRoute,
} as any);
const StudioConnectorsRoute = StudioConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => StudioRoute,
} as any);
const StudioCustomerIdentityRoute = StudioCustomerIdentityRouteImport.update({
  id: '/customer-identity',
  path: '/customer-identity',
  getParentRoute: () => StudioRoute,
} as any);
const StudioDecisionsRoute = StudioDecisionsRouteImport.update({
  id: '/decisions',
  path: '/decisions',
  getParentRoute: () => StudioRoute,
} as any);
const StudioDeveloperRoute = StudioDeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => StudioRoute,
} as any);
const StudioFinanceRoute = StudioFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => StudioRoute,
} as any);
const StudioHoursRoute = StudioHoursRouteImport.update({
  id: '/hours',
  path: '/hours',
  getParentRoute: () => StudioRoute,
} as any);
const StudioInboxRoute = StudioInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => StudioRoute,
} as any);
const StudioKnowledgeRoute = StudioKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => StudioRoute,
} as any);
const StudioMigrationRoute = StudioMigrationRouteImport.update({
  id: '/migration',
  path: '/migration',
  getParentRoute: () => StudioRoute,
} as any);
const StudioModelsRoute = StudioModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => StudioRoute,
} as any);
const StudioOnboardingRoute = StudioOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => StudioRoute,
} as any);
const StudioOverviewRoute = StudioOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => StudioRoute,
} as any);
const StudioReportsRoute = StudioReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => StudioRoute,
} as any);
const StudioRunsRoute = StudioRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => StudioRoute,
} as any);
const StudioSavedRepliesRoute = StudioSavedRepliesRouteImport.update({
  id: '/saved-replies',
  path: '/saved-replies',
  getParentRoute: () => StudioRoute,
} as any);
const StudioSecurityRoute = StudioSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => StudioRoute,
} as any);
const StudioStopAiRoute = StudioStopAiRouteImport.update({
  id: '/stop-ai',
  path: '/stop-ai',
  getParentRoute: () => StudioRoute,
} as any);
const StudioSupportTeamsRoute = StudioSupportTeamsRouteImport.update({
  id: '/support-teams',
  path: '/support-teams',
  getParentRoute: () => StudioRoute,
} as any);
const StudioTeamRoute = StudioTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => StudioRoute,
} as any);
const StudioToolsRoute = StudioToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => StudioRoute,
} as any);
const StudioVisitorsRoute = StudioVisitorsRouteImport.update({
  id: '/visitors',
  path: '/visitors',
  getParentRoute: () => StudioRoute,
} as any);
const StudioWorkflowsRoute = StudioWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => StudioRoute,
} as any);
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => rootRouteImport,
} as any);
const SsoDoneRoute = SsoDoneRouteImport.update({
  id: '/sso/done',
  path: '/sso/done',
  getParentRoute: () => rootRouteImport,
} as any);
const StudioAgentsIndexRoute = StudioAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => StudioRoute,
} as any);
const StudioAgentsAgentIdRoute = StudioAgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => StudioRoute,
} as any);
const StudioAutomationsIndexRoute = StudioAutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => StudioRoute,
} as any);
const StudioAutomationsAutomationIdRoute =
  StudioAutomationsAutomationIdRouteImport.update({
    id: '/automations/$automationId',
    path: '/automations/$automationId',
    getParentRoute: () => StudioRoute,
  } as any);
const StudioConnectMcpRoute = StudioConnectMcpRouteImport.update({
  id: '/connect/mcp',
  path: '/connect/mcp',
  getParentRoute: () => StudioRoute,
} as any);
const StudioInboxIndexRoute = StudioInboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioInboxRoute,
} as any);
const StudioInboxConversationIdRoute =
  StudioInboxConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => StudioInboxRoute,
  } as any);
const StudioMemoryIndexRoute = StudioMemoryIndexRouteImport.update({
  id: '/memory/',
  path: '/memory/',
  getParentRoute: () => StudioRoute,
} as any);
const StudioMemoryCustomerIdRoute = StudioMemoryCustomerIdRouteImport.update({
  id: '/memory/$customerId',
  path: '/memory/$customerId',
  getParentRoute: () => StudioRoute,
} as any);
const StudioOrdersIndexRoute = StudioOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => StudioRoute,
} as any);
const StudioOrdersOrderIdRoute = StudioOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => StudioRoute,
} as any);
const StudioSettingsBillingRoute = StudioSettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => StudioRoute,
} as any);
const StudioSettingsPrivacyRoute = StudioSettingsPrivacyRouteImport.update({
  id: '/settings/privacy',
  path: '/settings/privacy',
  getParentRoute: () => StudioRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/platform': typeof PlatformRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in': typeof SignInRoute;
  '/sign-up': typeof SignUpRoute;
  '/tenants': typeof TenantsRoute;
  '/account': typeof StudioAccountRoute;
  '/agency': typeof StudioAgencyRoute;
  '/blocked': typeof StudioBlockedRoute;
  '/branding': typeof StudioBrandingRoute;
  '/brands': typeof StudioBrandsRoute;
  '/caching': typeof StudioCachingRoute;
  '/channels': typeof StudioChannelsRoute;
  '/chat-widget': typeof StudioChatWidgetRoute;
  '/checks': typeof StudioChecksRoute;
  '/connectors': typeof StudioConnectorsRoute;
  '/customer-identity': typeof StudioCustomerIdentityRoute;
  '/decisions': typeof StudioDecisionsRoute;
  '/developer': typeof StudioDeveloperRoute;
  '/finance': typeof StudioFinanceRoute;
  '/hours': typeof StudioHoursRoute;
  '/inbox': typeof StudioInboxRouteWithChildren;
  '/knowledge': typeof StudioKnowledgeRoute;
  '/migration': typeof StudioMigrationRoute;
  '/models': typeof StudioModelsRoute;
  '/onboarding': typeof StudioOnboardingRoute;
  '/overview': typeof StudioOverviewRoute;
  '/reports': typeof StudioReportsRoute;
  '/runs': typeof StudioRunsRoute;
  '/saved-replies': typeof StudioSavedRepliesRoute;
  '/security': typeof StudioSecurityRoute;
  '/stop-ai': typeof StudioStopAiRoute;
  '/support-teams': typeof StudioSupportTeamsRoute;
  '/team': typeof StudioTeamRoute;
  '/tools': typeof StudioToolsRoute;
  '/visitors': typeof StudioVisitorsRoute;
  '/workflows': typeof StudioWorkflowsRoute;
  '/invitations/accept': typeof InvitationsAcceptRoute;
  '/sso/done': typeof SsoDoneRoute;
  '/agents/$agentId': typeof StudioAgentsAgentIdRoute;
  '/automations/$automationId': typeof StudioAutomationsAutomationIdRoute;
  '/connect/mcp': typeof StudioConnectMcpRoute;
  '/inbox/$conversationId': typeof StudioInboxConversationIdRoute;
  '/memory/$customerId': typeof StudioMemoryCustomerIdRoute;
  '/orders/$orderId': typeof StudioOrdersOrderIdRoute;
  '/settings/billing': typeof StudioSettingsBillingRoute;
  '/settings/privacy': typeof StudioSettingsPrivacyRoute;
  '/agents/': typeof StudioAgentsIndexRoute;
  '/automations/': typeof StudioAutomationsIndexRoute;
  '/inbox/': typeof StudioInboxIndexRoute;
  '/memory/': typeof StudioMemoryIndexRoute;
  '/orders/': typeof StudioOrdersIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/platform': typeof PlatformRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in': typeof SignInRoute;
  '/sign-up': typeof SignUpRoute;
  '/tenants': typeof TenantsRoute;
  '/account': typeof StudioAccountRoute;
  '/agency': typeof StudioAgencyRoute;
  '/blocked': typeof StudioBlockedRoute;
  '/branding': typeof StudioBrandingRoute;
  '/brands': typeof StudioBrandsRoute;
  '/caching': typeof StudioCachingRoute;
  '/channels': typeof StudioChannelsRoute;
  '/chat-widget': typeof StudioChatWidgetRoute;
  '/checks': typeof StudioChecksRoute;
  '/connectors': typeof StudioConnectorsRoute;
  '/customer-identity': typeof StudioCustomerIdentityRoute;
  '/decisions': typeof StudioDecisionsRoute;
  '/developer': typeof StudioDeveloperRoute;
  '/finance': typeof StudioFinanceRoute;
  '/hours': typeof StudioHoursRoute;
  '/knowledge': typeof StudioKnowledgeRoute;
  '/migration': typeof StudioMigrationRoute;
  '/models': typeof StudioModelsRoute;
  '/onboarding': typeof StudioOnboardingRoute;
  '/overview': typeof StudioOverviewRoute;
  '/reports': typeof StudioReportsRoute;
  '/runs': typeof StudioRunsRoute;
  '/saved-replies': typeof StudioSavedRepliesRoute;
  '/security': typeof StudioSecurityRoute;
  '/stop-ai': typeof StudioStopAiRoute;
  '/support-teams': typeof StudioSupportTeamsRoute;
  '/team': typeof StudioTeamRoute;
  '/tools': typeof StudioToolsRoute;
  '/visitors': typeof StudioVisitorsRoute;
  '/workflows': typeof StudioWorkflowsRoute;
  '/invitations/accept': typeof InvitationsAcceptRoute;
  '/sso/done': typeof SsoDoneRoute;
  '/agents/$agentId': typeof StudioAgentsAgentIdRoute;
  '/automations/$automationId': typeof StudioAutomationsAutomationIdRoute;
  '/connect/mcp': typeof StudioConnectMcpRoute;
  '/inbox/$conversationId': typeof StudioInboxConversationIdRoute;
  '/memory/$customerId': typeof StudioMemoryCustomerIdRoute;
  '/orders/$orderId': typeof StudioOrdersOrderIdRoute;
  '/settings/billing': typeof StudioSettingsBillingRoute;
  '/settings/privacy': typeof StudioSettingsPrivacyRoute;
  '/agents': typeof StudioAgentsIndexRoute;
  '/automations': typeof StudioAutomationsIndexRoute;
  '/inbox': typeof StudioInboxIndexRoute;
  '/memory': typeof StudioMemoryIndexRoute;
  '/orders': typeof StudioOrdersIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_studio': typeof StudioRouteWithChildren;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/platform': typeof PlatformRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in': typeof SignInRoute;
  '/sign-up': typeof SignUpRoute;
  '/tenants': typeof TenantsRoute;
  '/_studio/account': typeof StudioAccountRoute;
  '/_studio/agency': typeof StudioAgencyRoute;
  '/_studio/blocked': typeof StudioBlockedRoute;
  '/_studio/branding': typeof StudioBrandingRoute;
  '/_studio/brands': typeof StudioBrandsRoute;
  '/_studio/caching': typeof StudioCachingRoute;
  '/_studio/channels': typeof StudioChannelsRoute;
  '/_studio/chat-widget': typeof StudioChatWidgetRoute;
  '/_studio/checks': typeof StudioChecksRoute;
  '/_studio/connectors': typeof StudioConnectorsRoute;
  '/_studio/customer-identity': typeof StudioCustomerIdentityRoute;
  '/_studio/decisions': typeof StudioDecisionsRoute;
  '/_studio/developer': typeof StudioDeveloperRoute;
  '/_studio/finance': typeof StudioFinanceRoute;
  '/_studio/hours': typeof StudioHoursRoute;
  '/_studio/inbox': typeof StudioInboxRouteWithChildren;
  '/_studio/knowledge': typeof StudioKnowledgeRoute;
  '/_studio/migration': typeof StudioMigrationRoute;
  '/_studio/models': typeof StudioModelsRoute;
  '/_studio/onboarding': typeof StudioOnboardingRoute;
  '/_studio/overview': typeof StudioOverviewRoute;
  '/_studio/reports': typeof StudioReportsRoute;
  '/_studio/runs': typeof StudioRunsRoute;
  '/_studio/saved-replies': typeof StudioSavedRepliesRoute;
  '/_studio/security': typeof StudioSecurityRoute;
  '/_studio/stop-ai': typeof StudioStopAiRoute;
  '/_studio/support-teams': typeof StudioSupportTeamsRoute;
  '/_studio/team': typeof StudioTeamRoute;
  '/_studio/tools': typeof StudioToolsRoute;
  '/_studio/visitors': typeof StudioVisitorsRoute;
  '/_studio/workflows': typeof StudioWorkflowsRoute;
  '/invitations/accept': typeof InvitationsAcceptRoute;
  '/sso/done': typeof SsoDoneRoute;
  '/_studio/agents/$agentId': typeof StudioAgentsAgentIdRoute;
  '/_studio/automations/$automationId': typeof StudioAutomationsAutomationIdRoute;
  '/_studio/connect/mcp': typeof StudioConnectMcpRoute;
  '/_studio/inbox/$conversationId': typeof StudioInboxConversationIdRoute;
  '/_studio/memory/$customerId': typeof StudioMemoryCustomerIdRoute;
  '/_studio/orders/$orderId': typeof StudioOrdersOrderIdRoute;
  '/_studio/settings/billing': typeof StudioSettingsBillingRoute;
  '/_studio/settings/privacy': typeof StudioSettingsPrivacyRoute;
  '/_studio/agents/': typeof StudioAgentsIndexRoute;
  '/_studio/automations/': typeof StudioAutomationsIndexRoute;
  '/_studio/inbox/': typeof StudioInboxIndexRoute;
  '/_studio/memory/': typeof StudioMemoryIndexRoute;
  '/_studio/orders/': typeof StudioOrdersIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/platform'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/tenants'
    | '/account'
    | '/agency'
    | '/blocked'
    | '/branding'
    | '/brands'
    | '/caching'
    | '/channels'
    | '/chat-widget'
    | '/checks'
    | '/connectors'
    | '/customer-identity'
    | '/decisions'
    | '/developer'
    | '/finance'
    | '/hours'
    | '/inbox'
    | '/knowledge'
    | '/migration'
    | '/models'
    | '/onboarding'
    | '/overview'
    | '/reports'
    | '/runs'
    | '/saved-replies'
    | '/security'
    | '/stop-ai'
    | '/support-teams'
    | '/team'
    | '/tools'
    | '/visitors'
    | '/workflows'
    | '/invitations/accept'
    | '/sso/done'
    | '/agents/$agentId'
    | '/automations/$automationId'
    | '/connect/mcp'
    | '/inbox/$conversationId'
    | '/memory/$customerId'
    | '/orders/$orderId'
    | '/settings/billing'
    | '/settings/privacy'
    | '/agents/'
    | '/automations/'
    | '/inbox/'
    | '/memory/'
    | '/orders/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/forgot-password'
    | '/platform'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/tenants'
    | '/account'
    | '/agency'
    | '/blocked'
    | '/branding'
    | '/brands'
    | '/caching'
    | '/channels'
    | '/chat-widget'
    | '/checks'
    | '/connectors'
    | '/customer-identity'
    | '/decisions'
    | '/developer'
    | '/finance'
    | '/hours'
    | '/knowledge'
    | '/migration'
    | '/models'
    | '/onboarding'
    | '/overview'
    | '/reports'
    | '/runs'
    | '/saved-replies'
    | '/security'
    | '/stop-ai'
    | '/support-teams'
    | '/team'
    | '/tools'
    | '/visitors'
    | '/workflows'
    | '/invitations/accept'
    | '/sso/done'
    | '/agents/$agentId'
    | '/automations/$automationId'
    | '/connect/mcp'
    | '/inbox/$conversationId'
    | '/memory/$customerId'
    | '/orders/$orderId'
    | '/settings/billing'
    | '/settings/privacy'
    | '/agents'
    | '/automations'
    | '/inbox'
    | '/memory'
    | '/orders';
  id:
    | '__root__'
    | '/'
    | '/_studio'
    | '/forgot-password'
    | '/platform'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/tenants'
    | '/_studio/account'
    | '/_studio/agency'
    | '/_studio/blocked'
    | '/_studio/branding'
    | '/_studio/brands'
    | '/_studio/caching'
    | '/_studio/channels'
    | '/_studio/chat-widget'
    | '/_studio/checks'
    | '/_studio/connectors'
    | '/_studio/customer-identity'
    | '/_studio/decisions'
    | '/_studio/developer'
    | '/_studio/finance'
    | '/_studio/hours'
    | '/_studio/inbox'
    | '/_studio/knowledge'
    | '/_studio/migration'
    | '/_studio/models'
    | '/_studio/onboarding'
    | '/_studio/overview'
    | '/_studio/reports'
    | '/_studio/runs'
    | '/_studio/saved-replies'
    | '/_studio/security'
    | '/_studio/stop-ai'
    | '/_studio/support-teams'
    | '/_studio/team'
    | '/_studio/tools'
    | '/_studio/visitors'
    | '/_studio/workflows'
    | '/invitations/accept'
    | '/sso/done'
    | '/_studio/agents/$agentId'
    | '/_studio/automations/$automationId'
    | '/_studio/connect/mcp'
    | '/_studio/inbox/$conversationId'
    | '/_studio/memory/$customerId'
    | '/_studio/orders/$orderId'
    | '/_studio/settings/billing'
    | '/_studio/settings/privacy'
    | '/_studio/agents/'
    | '/_studio/automations/'
    | '/_studio/inbox/'
    | '/_studio/memory/'
    | '/_studio/orders/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  StudioRoute: typeof StudioRouteWithChildren;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  PlatformRoute: typeof PlatformRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  SignInRoute: typeof SignInRoute;
  SignUpRoute: typeof SignUpRoute;
  TenantsRoute: typeof TenantsRoute;
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute;
  SsoDoneRoute: typeof SsoDoneRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_studio': {
      id: '/_studio';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof StudioRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform': {
      id: '/platform';
      path: '/platform';
      fullPath: '/platform';
      preLoaderRoute: typeof PlatformRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sign-in': {
      id: '/sign-in';
      path: '/sign-in';
      fullPath: '/sign-in';
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sign-up': {
      id: '/sign-up';
      path: '/sign-up';
      fullPath: '/sign-up';
      preLoaderRoute: typeof SignUpRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tenants': {
      id: '/tenants';
      path: '/tenants';
      fullPath: '/tenants';
      preLoaderRoute: typeof TenantsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_studio/account': {
      id: '/_studio/account';
      path: '/account';
      fullPath: '/account';
      preLoaderRoute: typeof StudioAccountRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/agency': {
      id: '/_studio/agency';
      path: '/agency';
      fullPath: '/agency';
      preLoaderRoute: typeof StudioAgencyRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/blocked': {
      id: '/_studio/blocked';
      path: '/blocked';
      fullPath: '/blocked';
      preLoaderRoute: typeof StudioBlockedRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/branding': {
      id: '/_studio/branding';
      path: '/branding';
      fullPath: '/branding';
      preLoaderRoute: typeof StudioBrandingRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/brands': {
      id: '/_studio/brands';
      path: '/brands';
      fullPath: '/brands';
      preLoaderRoute: typeof StudioBrandsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/caching': {
      id: '/_studio/caching';
      path: '/caching';
      fullPath: '/caching';
      preLoaderRoute: typeof StudioCachingRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/channels': {
      id: '/_studio/channels';
      path: '/channels';
      fullPath: '/channels';
      preLoaderRoute: typeof StudioChannelsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/chat-widget': {
      id: '/_studio/chat-widget';
      path: '/chat-widget';
      fullPath: '/chat-widget';
      preLoaderRoute: typeof StudioChatWidgetRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/checks': {
      id: '/_studio/checks';
      path: '/checks';
      fullPath: '/checks';
      preLoaderRoute: typeof StudioChecksRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/connectors': {
      id: '/_studio/connectors';
      path: '/connectors';
      fullPath: '/connectors';
      preLoaderRoute: typeof StudioConnectorsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/customer-identity': {
      id: '/_studio/customer-identity';
      path: '/customer-identity';
      fullPath: '/customer-identity';
      preLoaderRoute: typeof StudioCustomerIdentityRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/decisions': {
      id: '/_studio/decisions';
      path: '/decisions';
      fullPath: '/decisions';
      preLoaderRoute: typeof StudioDecisionsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/developer': {
      id: '/_studio/developer';
      path: '/developer';
      fullPath: '/developer';
      preLoaderRoute: typeof StudioDeveloperRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/finance': {
      id: '/_studio/finance';
      path: '/finance';
      fullPath: '/finance';
      preLoaderRoute: typeof StudioFinanceRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/hours': {
      id: '/_studio/hours';
      path: '/hours';
      fullPath: '/hours';
      preLoaderRoute: typeof StudioHoursRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/inbox': {
      id: '/_studio/inbox';
      path: '/inbox';
      fullPath: '/inbox';
      preLoaderRoute: typeof StudioInboxRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/knowledge': {
      id: '/_studio/knowledge';
      path: '/knowledge';
      fullPath: '/knowledge';
      preLoaderRoute: typeof StudioKnowledgeRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/migration': {
      id: '/_studio/migration';
      path: '/migration';
      fullPath: '/migration';
      preLoaderRoute: typeof StudioMigrationRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/models': {
      id: '/_studio/models';
      path: '/models';
      fullPath: '/models';
      preLoaderRoute: typeof StudioModelsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/onboarding': {
      id: '/_studio/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof StudioOnboardingRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/overview': {
      id: '/_studio/overview';
      path: '/overview';
      fullPath: '/overview';
      preLoaderRoute: typeof StudioOverviewRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/reports': {
      id: '/_studio/reports';
      path: '/reports';
      fullPath: '/reports';
      preLoaderRoute: typeof StudioReportsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/runs': {
      id: '/_studio/runs';
      path: '/runs';
      fullPath: '/runs';
      preLoaderRoute: typeof StudioRunsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/saved-replies': {
      id: '/_studio/saved-replies';
      path: '/saved-replies';
      fullPath: '/saved-replies';
      preLoaderRoute: typeof StudioSavedRepliesRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/security': {
      id: '/_studio/security';
      path: '/security';
      fullPath: '/security';
      preLoaderRoute: typeof StudioSecurityRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/stop-ai': {
      id: '/_studio/stop-ai';
      path: '/stop-ai';
      fullPath: '/stop-ai';
      preLoaderRoute: typeof StudioStopAiRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/support-teams': {
      id: '/_studio/support-teams';
      path: '/support-teams';
      fullPath: '/support-teams';
      preLoaderRoute: typeof StudioSupportTeamsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/team': {
      id: '/_studio/team';
      path: '/team';
      fullPath: '/team';
      preLoaderRoute: typeof StudioTeamRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/tools': {
      id: '/_studio/tools';
      path: '/tools';
      fullPath: '/tools';
      preLoaderRoute: typeof StudioToolsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/visitors': {
      id: '/_studio/visitors';
      path: '/visitors';
      fullPath: '/visitors';
      preLoaderRoute: typeof StudioVisitorsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/workflows': {
      id: '/_studio/workflows';
      path: '/workflows';
      fullPath: '/workflows';
      preLoaderRoute: typeof StudioWorkflowsRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/invitations/accept': {
      id: '/invitations/accept';
      path: '/invitations/accept';
      fullPath: '/invitations/accept';
      preLoaderRoute: typeof InvitationsAcceptRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sso/done': {
      id: '/sso/done';
      path: '/sso/done';
      fullPath: '/sso/done';
      preLoaderRoute: typeof SsoDoneRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_studio/agents/': {
      id: '/_studio/agents/';
      path: '/agents';
      fullPath: '/agents/';
      preLoaderRoute: typeof StudioAgentsIndexRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/agents/$agentId': {
      id: '/_studio/agents/$agentId';
      path: '/agents/$agentId';
      fullPath: '/agents/$agentId';
      preLoaderRoute: typeof StudioAgentsAgentIdRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/automations/': {
      id: '/_studio/automations/';
      path: '/automations';
      fullPath: '/automations/';
      preLoaderRoute: typeof StudioAutomationsIndexRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/automations/$automationId': {
      id: '/_studio/automations/$automationId';
      path: '/automations/$automationId';
      fullPath: '/automations/$automationId';
      preLoaderRoute: typeof StudioAutomationsAutomationIdRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/connect/mcp': {
      id: '/_studio/connect/mcp';
      path: '/connect/mcp';
      fullPath: '/connect/mcp';
      preLoaderRoute: typeof StudioConnectMcpRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/inbox/': {
      id: '/_studio/inbox/';
      path: '/';
      fullPath: '/inbox/';
      preLoaderRoute: typeof StudioInboxIndexRouteImport;
      parentRoute: typeof StudioInboxRoute;
    };
    '/_studio/inbox/$conversationId': {
      id: '/_studio/inbox/$conversationId';
      path: '/$conversationId';
      fullPath: '/inbox/$conversationId';
      preLoaderRoute: typeof StudioInboxConversationIdRouteImport;
      parentRoute: typeof StudioInboxRoute;
    };
    '/_studio/memory/': {
      id: '/_studio/memory/';
      path: '/memory';
      fullPath: '/memory/';
      preLoaderRoute: typeof StudioMemoryIndexRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/memory/$customerId': {
      id: '/_studio/memory/$customerId';
      path: '/memory/$customerId';
      fullPath: '/memory/$customerId';
      preLoaderRoute: typeof StudioMemoryCustomerIdRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/orders/': {
      id: '/_studio/orders/';
      path: '/orders';
      fullPath: '/orders/';
      preLoaderRoute: typeof StudioOrdersIndexRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/orders/$orderId': {
      id: '/_studio/orders/$orderId';
      path: '/orders/$orderId';
      fullPath: '/orders/$orderId';
      preLoaderRoute: typeof StudioOrdersOrderIdRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/settings/billing': {
      id: '/_studio/settings/billing';
      path: '/settings/billing';
      fullPath: '/settings/billing';
      preLoaderRoute: typeof StudioSettingsBillingRouteImport;
      parentRoute: typeof StudioRoute;
    };
    '/_studio/settings/privacy': {
      id: '/_studio/settings/privacy';
      path: '/settings/privacy';
      fullPath: '/settings/privacy';
      preLoaderRoute: typeof StudioSettingsPrivacyRouteImport;
      parentRoute: typeof StudioRoute;
    };
  }
}

interface StudioInboxRouteChildren {
  StudioInboxConversationIdRoute: typeof StudioInboxConversationIdRoute;
  StudioInboxIndexRoute: typeof StudioInboxIndexRoute;
}

const StudioInboxRouteChildren: StudioInboxRouteChildren = {
  StudioInboxConversationIdRoute: StudioInboxConversationIdRoute,
  StudioInboxIndexRoute: StudioInboxIndexRoute,
};

const StudioInboxRouteWithChildren = StudioInboxRoute._addFileChildren(
  StudioInboxRouteChildren,
);

interface StudioRouteChildren {
  StudioAccountRoute: typeof StudioAccountRoute;
  StudioAgencyRoute: typeof StudioAgencyRoute;
  StudioBlockedRoute: typeof StudioBlockedRoute;
  StudioBrandingRoute: typeof StudioBrandingRoute;
  StudioBrandsRoute: typeof StudioBrandsRoute;
  StudioCachingRoute: typeof StudioCachingRoute;
  StudioChannelsRoute: typeof StudioChannelsRoute;
  StudioChatWidgetRoute: typeof StudioChatWidgetRoute;
  StudioChecksRoute: typeof StudioChecksRoute;
  StudioConnectorsRoute: typeof StudioConnectorsRoute;
  StudioCustomerIdentityRoute: typeof StudioCustomerIdentityRoute;
  StudioDecisionsRoute: typeof StudioDecisionsRoute;
  StudioDeveloperRoute: typeof StudioDeveloperRoute;
  StudioFinanceRoute: typeof StudioFinanceRoute;
  StudioHoursRoute: typeof StudioHoursRoute;
  StudioInboxRoute: typeof StudioInboxRouteWithChildren;
  StudioKnowledgeRoute: typeof StudioKnowledgeRoute;
  StudioMigrationRoute: typeof StudioMigrationRoute;
  StudioModelsRoute: typeof StudioModelsRoute;
  StudioOnboardingRoute: typeof StudioOnboardingRoute;
  StudioOverviewRoute: typeof StudioOverviewRoute;
  StudioReportsRoute: typeof StudioReportsRoute;
  StudioRunsRoute: typeof StudioRunsRoute;
  StudioSavedRepliesRoute: typeof StudioSavedRepliesRoute;
  StudioSecurityRoute: typeof StudioSecurityRoute;
  StudioStopAiRoute: typeof StudioStopAiRoute;
  StudioSupportTeamsRoute: typeof StudioSupportTeamsRoute;
  StudioTeamRoute: typeof StudioTeamRoute;
  StudioToolsRoute: typeof StudioToolsRoute;
  StudioVisitorsRoute: typeof StudioVisitorsRoute;
  StudioWorkflowsRoute: typeof StudioWorkflowsRoute;
  StudioAgentsAgentIdRoute: typeof StudioAgentsAgentIdRoute;
  StudioAutomationsAutomationIdRoute: typeof StudioAutomationsAutomationIdRoute;
  StudioConnectMcpRoute: typeof StudioConnectMcpRoute;
  StudioMemoryCustomerIdRoute: typeof StudioMemoryCustomerIdRoute;
  StudioOrdersOrderIdRoute: typeof StudioOrdersOrderIdRoute;
  StudioSettingsBillingRoute: typeof StudioSettingsBillingRoute;
  StudioSettingsPrivacyRoute: typeof StudioSettingsPrivacyRoute;
  StudioAgentsIndexRoute: typeof StudioAgentsIndexRoute;
  StudioAutomationsIndexRoute: typeof StudioAutomationsIndexRoute;
  StudioMemoryIndexRoute: typeof StudioMemoryIndexRoute;
  StudioOrdersIndexRoute: typeof StudioOrdersIndexRoute;
}

const StudioRouteChildren: StudioRouteChildren = {
  StudioAccountRoute: StudioAccountRoute,
  StudioAgencyRoute: StudioAgencyRoute,
  StudioBlockedRoute: StudioBlockedRoute,
  StudioBrandingRoute: StudioBrandingRoute,
  StudioBrandsRoute: StudioBrandsRoute,
  StudioCachingRoute: StudioCachingRoute,
  StudioChannelsRoute: StudioChannelsRoute,
  StudioChatWidgetRoute: StudioChatWidgetRoute,
  StudioChecksRoute: StudioChecksRoute,
  StudioConnectorsRoute: StudioConnectorsRoute,
  StudioCustomerIdentityRoute: StudioCustomerIdentityRoute,
  StudioDecisionsRoute: StudioDecisionsRoute,
  StudioDeveloperRoute: StudioDeveloperRoute,
  StudioFinanceRoute: StudioFinanceRoute,
  StudioHoursRoute: StudioHoursRoute,
  StudioInboxRoute: StudioInboxRouteWithChildren,
  StudioKnowledgeRoute: StudioKnowledgeRoute,
  StudioMigrationRoute: StudioMigrationRoute,
  StudioModelsRoute: StudioModelsRoute,
  StudioOnboardingRoute: StudioOnboardingRoute,
  StudioOverviewRoute: StudioOverviewRoute,
  StudioReportsRoute: StudioReportsRoute,
  StudioRunsRoute: StudioRunsRoute,
  StudioSavedRepliesRoute: StudioSavedRepliesRoute,
  StudioSecurityRoute: StudioSecurityRoute,
  StudioStopAiRoute: StudioStopAiRoute,
  StudioSupportTeamsRoute: StudioSupportTeamsRoute,
  StudioTeamRoute: StudioTeamRoute,
  StudioToolsRoute: StudioToolsRoute,
  StudioVisitorsRoute: StudioVisitorsRoute,
  StudioWorkflowsRoute: StudioWorkflowsRoute,
  StudioAgentsAgentIdRoute: StudioAgentsAgentIdRoute,
  StudioAutomationsAutomationIdRoute: StudioAutomationsAutomationIdRoute,
  StudioConnectMcpRoute: StudioConnectMcpRoute,
  StudioMemoryCustomerIdRoute: StudioMemoryCustomerIdRoute,
  StudioOrdersOrderIdRoute: StudioOrdersOrderIdRoute,
  StudioSettingsBillingRoute: StudioSettingsBillingRoute,
  StudioSettingsPrivacyRoute: StudioSettingsPrivacyRoute,
  StudioAgentsIndexRoute: StudioAgentsIndexRoute,
  StudioAutomationsIndexRoute: StudioAutomationsIndexRoute,
  StudioMemoryIndexRoute: StudioMemoryIndexRoute,
  StudioOrdersIndexRoute: StudioOrdersIndexRoute,
};

const StudioRouteWithChildren =
  StudioRoute._addFileChildren(StudioRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  StudioRoute: StudioRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  PlatformRoute: PlatformRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TenantsRoute: TenantsRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
  SsoDoneRoute: SsoDoneRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
